import React from 'react'
import type { TFunction } from 'i18next'
import type { TaxEfficiencyRating } from '@popety-io/types'
import { getEfficiencyVariant } from '../taxService'
import {
  TaxInsightCard,
  TaxInsightIcon,
  TaxInsightContent,
  TaxInsightTitle,
  TaxInsightText,
} from '../TaxSection.styles'

export interface InsightCardProps {
  rating: TaxEfficiencyRating
  interpretation: string
  t: TFunction
}

export const InsightCard: React.FC<InsightCardProps> = ({
  rating,
  interpretation,
  t,
}) => {
  const variant = getEfficiencyVariant(rating)

  const getIcon = () => {
    switch (variant) {
      case 'high':
        return '✓'
      case 'medium':
        return '⚖️'
      case 'low':
        return '⚠️'
      default:
        return '💡'
    }
  }

  const getRatingLabel = () => {
    switch (rating) {
      case 'high':
        return t('efficiency.high')
      case 'medium':
        return t('efficiency.medium')
      case 'low':
        return t('efficiency.low')
      default:
        return rating
    }
  }

  const getInsightMessage = () => {
    switch (variant) {
      case 'high':
        return t('insights.highEfficiency')
      case 'medium':
        return t('insights.mediumEfficiency')
      case 'low':
        return t('insights.lowEfficiency')
      default:
        return interpretation
    }
  }

  return (
    <TaxInsightCard $variant={variant}>
      <TaxInsightIcon>{getIcon()}</TaxInsightIcon>
      <TaxInsightContent>
        <TaxInsightTitle>
          {t('insights.title')}: {getRatingLabel()}
        </TaxInsightTitle>
        <TaxInsightText>{getInsightMessage()}</TaxInsightText>
      </TaxInsightContent>
    </TaxInsightCard>
  )
}
